import React from 'react';

import classes from './SearchResultWrapper.scss';

const searchResultWrapper = (props) => (
    <div className={classes.Wrapper}>
        {props.children}
    </div>
);  

export default searchResultWrapper;


// WEBPACK FOOTER //
// ./src/components/UI/Wrappers/SearchResultWrapper/SearchResultWrapper.js